__turbopack_context__.v({
  "FeatureCard": "FeatureCard-module-scss-module__zm9enq__FeatureCard",
  "FeatureCard--black": "FeatureCard-module-scss-module__zm9enq__FeatureCard--black",
  "FeatureCard--no-links": "FeatureCard-module-scss-module__zm9enq__FeatureCard--no-links",
  "FeatureCard--wide": "FeatureCard-module-scss-module__zm9enq__FeatureCard--wide",
  "FeatureCardContent": "FeatureCard-module-scss-module__zm9enq__FeatureCardContent",
  "FeatureCardCta": "FeatureCard-module-scss-module__zm9enq__FeatureCardCta",
  "FeatureCardImage": "FeatureCard-module-scss-module__zm9enq__FeatureCardImage",
  "FeatureCardImage--desktop": "FeatureCard-module-scss-module__zm9enq__FeatureCardImage--desktop",
  "FeatureCardImage--mobile": "FeatureCard-module-scss-module__zm9enq__FeatureCardImage--mobile",
  "FeatureCardImageWrapper": "FeatureCard-module-scss-module__zm9enq__FeatureCardImageWrapper",
  "FeatureCardLink": "FeatureCard-module-scss-module__zm9enq__FeatureCardLink",
  "FeatureCardLinkGroup": "FeatureCard-module-scss-module__zm9enq__FeatureCardLinkGroup",
  "FeatureCardLinks": "FeatureCard-module-scss-module__zm9enq__FeatureCardLinks",
  "FeatureCardLinksList": "FeatureCard-module-scss-module__zm9enq__FeatureCardLinksList",
  "FeatureCardLinksTitle": "FeatureCard-module-scss-module__zm9enq__FeatureCardLinksTitle",
  "FeatureCardText": "FeatureCard-module-scss-module__zm9enq__FeatureCardText",
  "FeatureCardTextGroup": "FeatureCard-module-scss-module__zm9enq__FeatureCardTextGroup",
  "FeatureCardTitle": "FeatureCard-module-scss-module__zm9enq__FeatureCardTitle",
  "FeatureCardTop": "FeatureCard-module-scss-module__zm9enq__FeatureCardTop",
});
